/// <reference path="../wpt.ts" />
var WPTNamespace;
(function (WPTNamespace) {
    var Widgets;
    (function (Widgets) {
        Widgets.TREE_ROOT = "[[ROOT]]";
        const LOG_CATEGORY = "WPT.Components.DataTree";
        const NODE_ID_PREFIX = "node-";
        const NODE_ID_ATTRIBUTE = "data-node-id";
        const NODE_LOADED_ATTRIBUTE = "data-node-loaded";
        const LEAF_ID_PREFIX = "leaf-";
        const LEAF_ID_ATTRIBUTE = "data-leaf-id";
        const SEARCH_NODE_ID_PREFIX = "search-node-";
        const SEARCH_LEAF_ID_PREFIX = "search-leaf-";
        const SEARCH_PARENT_ID_ATTRIBUTE = "data-search-parent-id";
        const ROOT_CLASS = "data-tree-root";
        const ITEM_CLASS = "data-tree-item";
        const NODE_OPENED_ITEM_CLASS = "data-tree-item--node-opened";
        const NODE_CLOSED_ITEM_CLASS = "data-tree-item--node-closed";
        const LEAF_ITEM_CLASS = "data-tree-item--leaf";
        const SEARCH_ITEM_CLASS = "data-tree-item--search";
        const ITEM_ICON_CLASS = "data-tree-item__icon";
        const ITEM_TEXT_CLASS = "data-tree-item__text";
        const ITEM_SEARCH_CLASS = "data-tree-item__search";
        const NODE_ICON_OPENED = "wpt-font wpt-font-folder_open";
        const NODE_ICON_CLOSED = "wpt-font wpt-font-folder";
        const LEAF_ICON = "wpt-font wpt-font-icon_Doc";
        const SEARCH_ICON = "wpt-font wpt-font-search";
        const SEARCH_INPUT_DIV_CLASSES = ["wpt-input", "wpt-input--full"];
        const SEARCH_INPUT_INPUT_CLASSES = ["wpt-input__input"];
        const SEARCH_INPUT_ICON_CLASSES = ['wpt-input__icons', 'wpt-input__icons--last'];
        const SEARCH_INPUT_ICON_ITEM_CLASSES = ['wpt-input__icons-item', 'wpt-input__icons-item--hover-primary'];
        class ComponentDataTree extends Widgets.ComponentBaseClass {
            constructor(core, container, parent, config) {
                super(core, container, parent);
                this._isReady = null;
                this._isWaitingDisplayData = null;
                this._componentDiv = null;
                this._currentTreeData = null;
                this._config = null;
                this._nodeIconOpened = null;
                this._nodeIconClosed = null;
                this._leafIcon = null;
                this._searchIcon = null;
                this._displayLeavesBeforeNodes = null;
                this._maxNodes = null;
                this._maxLeaves = null;
                this._nodeSearchText = null;
                this._leafSearchText = null;
                this._moreNodesText = null;
                this._moreLeavesText = null;
                this._noNodesText = null;
                this._noLeavesText = null;
                this._loadNodeCallback = null;
                this._selectNodeCallback = null;
                this._selectLeafCallback = null;
                this._searchNodeCallback = null;
                this._searchLeafCallback = null;
                this.displayData = (data) => {
                    this._log.info("DataTreeComponent.displayData()");
                    this._currentTreeData = data;
                    if (this._isReady)
                        this._displayData();
                    else
                        this._isWaitingDisplayData = true;
                };
                this.appendData = (data) => {
                    this._log.info("DataTreeComponent.appendData()");
                    // ignore if not ready
                    if (!this._isReady)
                        return;
                    let parentItem = this._componentDiv.querySelector('li#' + NODE_ID_PREFIX + data.Id);
                    let itemSpan = parentItem.querySelector('.' + ITEM_CLASS);
                    let childList = parentItem.querySelector('ul');
                    let fragment = document.createDocumentFragment();
                    this._addContent(fragment, data);
                    itemSpan.setAttribute(NODE_LOADED_ATTRIBUTE, 'true');
                    childList.appendChild(fragment);
                };
                this.addNodeSearchResult = (parentId, data) => {
                    this._log.info("DataTreeComponent.addNodeSearchResult()");
                    // ignore if not ready
                    if (!this._isReady)
                        return;
                    let parentItem = this._componentDiv.querySelector('li#' + NODE_ID_PREFIX + parentId);
                    let childList = null;
                    if (parentItem != null) {
                        // parent folder found, use child list of it
                        childList = parentItem.querySelector('ul');
                    }
                    else {
                        // no parent folder found, assuming ommitted root folder, use root child list
                        childList = this._componentDiv.querySelector('ul.' + ROOT_CLASS);
                    }
                    let searchNode = childList.querySelector('li#' + SEARCH_NODE_ID_PREFIX + parentId);
                    let searchInput = searchNode.querySelector('.wpt-input__input');
                    let existingChildNode = childList.querySelector('li#' + NODE_ID_PREFIX + data.Id);
                    if (!existingChildNode) {
                        if (this._log.isTraceEnabled()) {
                            this._log.trace("adding child node: " + data.Id);
                        }
                        let childNode = this._createNodeItem(data);
                        childList.insertBefore(childNode, searchNode);
                    }
                    else {
                        if (this._log.isTraceEnabled()) {
                            this._log.trace("child node already existing, do nothing...");
                        }
                    }
                    this._core.Functions.clearInputElement(searchInput);
                };
                this.addLeafSearchResult = (parentId, data) => {
                    this._log.info("DataTreeComponent.addLeafSearchResult()");
                    // ignore if not ready
                    if (!this._isReady)
                        return;
                    let parentItem = this._componentDiv.querySelector('li#' + NODE_ID_PREFIX + parentId);
                    let childList = parentItem.querySelector('ul');
                    let searchLeaf = childList.querySelector('li#' + SEARCH_LEAF_ID_PREFIX + parentId);
                    let searchInput = searchLeaf.querySelector('.wpt-input__input');
                    let existingLeaf = childList.querySelector('li#' + LEAF_ID_PREFIX + data.Id);
                    if (!existingLeaf) {
                        if (this._log.isTraceEnabled()) {
                            this._log.trace("adding leaf: " + data.Id);
                        }
                        let leafItem = this._createLeafItem(data);
                        childList.insertBefore(leafItem, searchLeaf);
                    }
                    else {
                        if (this._log.isTraceEnabled()) {
                            this._log.trace("leaf already existing, do nothing...");
                        }
                    }
                    this._core.Functions.clearInputElement(searchInput);
                };
                this.clearLeafSelection = () => {
                    this._log.info("DataTreeComponent.clearLeafSelection()");
                    // ignore if not ready
                    if (!this._isReady)
                        return;
                    let selectedLeaves = this._componentDiv.querySelectorAll('.' + ITEM_CLASS + '.' + Widgets.WIDGET_SELECTED_CLASS);
                    selectedLeaves.forEach(leaf => {
                        leaf.classList.remove(Widgets.WIDGET_SELECTED_CLASS);
                    });
                };
                this.selectLeaf = (id) => {
                    this._log.info("DataTreeComponent.selectLeaf()");
                    // ignore if not ready
                    if (!this._isReady)
                        return;
                    let leafItem = this._componentDiv.querySelector('.' + ITEM_CLASS + '[' + LEAF_ID_ATTRIBUTE + '="' + id + '"]');
                    leafItem.classList.add(Widgets.WIDGET_SELECTED_CLASS);
                };
                this.filterLeaves = (search) => {
                    this._log.info("DataTreeComponent.filterLeaves()");
                    // ignore if not ready
                    if (!this._isReady)
                        return;
                    let leaves = this._componentDiv.querySelectorAll('.' + LEAF_ITEM_CLASS);
                    leaves.forEach(leaf => {
                        let nameSpan = leaf.querySelector('.' + ITEM_TEXT_CLASS);
                        if (leaf.classList.contains(Widgets.WIDGET_SELECTED_CLASS) || nameSpan.innerText.toLowerCase().indexOf(search.toLowerCase()) > -1) {
                            leaf.parentElement.style.display = "";
                        }
                        else {
                            leaf.parentElement.style.display = "none";
                        }
                    });
                };
                this._present = () => {
                    this._log.info("DataTreeComponent._present()");
                    this._container.innerHTML = ComponentDataTree.Html;
                    this._componentDiv = this._container.querySelector('.widget-component--data-tree');
                    this._isReady = true;
                    if (this._isWaitingDisplayData)
                        this._displayData();
                };
                this._storeHtml = (htmlData) => {
                    this._log.info("DataTreeComponent._storeHtml()");
                    ComponentDataTree.Html = htmlData;
                    this._readyToPresent = true;
                    if (this._waitingToPresent)
                        this._present();
                };
                this._displayData = () => {
                    this._log.info("DataTreeComponent._displayData()");
                    this._componentDiv.innerHTML = "";
                    let fragement = document.createDocumentFragment();
                    let rootNode = document.createElement('ul');
                    fragement.appendChild(rootNode);
                    rootNode.classList.add(ROOT_CLASS);
                    if (this._currentTreeData) {
                        this._addContent(rootNode, this._currentTreeData);
                    }
                    this._componentDiv.appendChild(fragement);
                };
                this._addContent = (parentNode, data) => {
                    this._log.info("DataTreeComponent._addContent()");
                    if (this._displayLeavesBeforeNodes) {
                        this._addLeaves(parentNode, data.Id, data.Leaves, data.HasMoreLeaves);
                        this._addNodes(parentNode, data.Id, data.Nodes, data.HasMoreNodes);
                    }
                    else {
                        this._addNodes(parentNode, data.Id, data.Nodes, data.HasMoreNodes);
                        this._addLeaves(parentNode, data.Id, data.Leaves, data.HasMoreLeaves);
                    }
                };
                this._addNodes = (parentNode, parentId, nodes, moreNodes = false) => {
                    this._log.info("DataTreeComponent._addNodes()");
                    let length = nodes.length;
                    if (this._maxNodes >= 0 && length > this._maxNodes && parentId != Widgets.TREE_ROOT) {
                        let searchItem = this._createNodeSearch(parentId);
                        parentNode.appendChild(searchItem);
                    }
                    else {
                        if (length <= 0 && this._noNodesText) {
                            let txtItem = this._createTextItem(this._noNodesText);
                            parentNode.appendChild(txtItem);
                        }
                        else {
                            for (let i = 0; i < length; i++) {
                                let nodeData = nodes[i];
                                let nodeItem = this._createNodeItem(nodeData);
                                parentNode.appendChild(nodeItem);
                                if (nodeData.Loaded) {
                                    if (this._log.isTraceEnabled()) {
                                        this._log.trace("added loaded child node, adding content...");
                                    }
                                    let nodeList = document.createElement('ul');
                                    nodeItem.appendChild(nodeList);
                                    this._addContent(nodeList, nodeData);
                                }
                            }
                            if (moreNodes) {
                                if (this._moreNodesText) {
                                    let txtItem = this._createTextItem(this._moreNodesText);
                                    parentNode.appendChild(txtItem);
                                }
                                else {
                                    let searchItem = this._createNodeSearch(parentId);
                                    parentNode.appendChild(searchItem);
                                }
                            }
                        }
                    }
                };
                this._createTextItem = (text) => {
                    this._log.info("DataTreeComponent._createTextItem()");
                    let txtItem = document.createElement('li');
                    txtItem.innerText = text;
                    return txtItem;
                };
                this._createNodeItem = (data) => {
                    this._log.info("DataTreeComponent._createNodeItem()");
                    let nodeItem = document.createElement('li');
                    nodeItem.id = NODE_ID_PREFIX + data.Id;
                    let nodeDiv = document.createElement('div');
                    nodeItem.appendChild(nodeDiv);
                    nodeDiv.addEventListener('click', this._nodeItemClicked);
                    nodeDiv.classList.add(ITEM_CLASS);
                    nodeDiv.setAttribute(NODE_ID_ATTRIBUTE, data.Id);
                    nodeDiv.setAttribute(NODE_LOADED_ATTRIBUTE, data.Loaded.toString());
                    let iconSpan = document.createElement('span');
                    nodeDiv.appendChild(iconSpan);
                    iconSpan.classList.add(ITEM_ICON_CLASS);
                    if (data.Loaded || (data.hasOwnProperty('DisplayOpened') && data.DisplayOpened)) {
                        nodeDiv.classList.add(NODE_OPENED_ITEM_CLASS);
                        iconSpan.classList.add(...this._nodeIconOpened);
                    }
                    else {
                        nodeDiv.classList.add(NODE_CLOSED_ITEM_CLASS);
                        iconSpan.classList.add(...this._nodeIconClosed);
                    }
                    let nameSpan = document.createElement('span');
                    nodeDiv.appendChild(nameSpan);
                    nameSpan.classList.add(ITEM_TEXT_CLASS);
                    nameSpan.textContent = data.DisplayName;
                    let childList = document.createElement('ul');
                    nodeItem.appendChild(childList);
                    return nodeItem;
                };
                this._createNodeSearch = (parentId) => {
                    this._log.info("DataTreeComponent._createNodeSearch()");
                    let searchItem = document.createElement('li');
                    searchItem.id = SEARCH_NODE_ID_PREFIX + parentId;
                    let nodeDiv = document.createElement('div');
                    searchItem.appendChild(nodeDiv);
                    nodeDiv.classList.add(ITEM_CLASS, NODE_CLOSED_ITEM_CLASS, SEARCH_ITEM_CLASS);
                    let iconSpan = document.createElement('span');
                    nodeDiv.appendChild(iconSpan);
                    iconSpan.classList.add(ITEM_ICON_CLASS, ...this._nodeIconClosed);
                    let searchDiv = document.createElement('div');
                    nodeDiv.appendChild(searchDiv);
                    searchDiv.classList.add(ITEM_SEARCH_CLASS);
                    let searchInputDiv = document.createElement('div');
                    searchDiv.appendChild(searchInputDiv);
                    searchInputDiv.classList.add(...SEARCH_INPUT_DIV_CLASSES);
                    searchInputDiv.setAttribute(SEARCH_PARENT_ID_ATTRIBUTE, parentId);
                    let searchInput = document.createElement('input');
                    searchInputDiv.appendChild(searchInput);
                    searchInput.type = 'search';
                    searchInput.classList.add(...SEARCH_INPUT_INPUT_CLASSES);
                    if (this._nodeSearchText) {
                        searchInput.placeholder = this._nodeSearchText;
                        searchInput.setAttribute('aria-label', this._nodeSearchText);
                    }
                    searchInput.addEventListener('keyup', this._nodeSearchKeyUp);
                    let searchIconDiv = document.createElement('div');
                    searchInputDiv.appendChild(searchIconDiv);
                    searchIconDiv.classList.add(...SEARCH_INPUT_ICON_CLASSES);
                    let searchIconSpan = document.createElement('span');
                    searchIconDiv.appendChild(searchIconSpan);
                    searchIconSpan.addEventListener('click', this._nodeSearchClicked);
                    searchIconSpan.classList.add(...SEARCH_INPUT_ICON_ITEM_CLASSES, ...this._searchIcon);
                    return searchItem;
                };
                this._nodeItemClicked = (event) => {
                    this._log.info("DataTreeComponent._nodeItemClicked()");
                    let clickedItem = event.currentTarget;
                    if (this._selectNodeCallback) {
                        let nodeId = clickedItem.getAttribute(NODE_ID_ATTRIBUTE);
                        this._selectNodeCallback(nodeId);
                    }
                    else {
                        if (clickedItem.classList.contains(NODE_OPENED_ITEM_CLASS)) {
                            this._openedNodeItemClicked(clickedItem);
                        }
                        else {
                            this._closedNodeItemClicked(clickedItem);
                        }
                    }
                };
                this._openedNodeItemClicked = (clickedItem) => {
                    this._log.info("DataTreeComponent._openedNodeItemClicked()");
                    let icon = clickedItem.querySelector('.' + ITEM_ICON_CLASS);
                    let childList = clickedItem.parentElement.querySelector('ul');
                    // switch classes
                    clickedItem.classList.remove(NODE_OPENED_ITEM_CLASS);
                    clickedItem.classList.add(NODE_CLOSED_ITEM_CLASS);
                    icon.classList.remove(...this._nodeIconOpened);
                    icon.classList.add(...this._nodeIconClosed);
                    // close children
                    this._core.Functions.hideElement(childList);
                };
                this._closedNodeItemClicked = (clickedItem) => {
                    this._log.info("DataTreeComponent._closedNodeItemClicked()");
                    let icon = clickedItem.querySelector('.' + ITEM_ICON_CLASS);
                    let childList = clickedItem.parentElement.querySelector('ul');
                    if (clickedItem.getAttribute(NODE_LOADED_ATTRIBUTE) == 'false') {
                        let nodeId = clickedItem.getAttribute(NODE_ID_ATTRIBUTE);
                        if (this._log.isTraceEnabled()) {
                            this._log.trace("need to load content for node: " + nodeId);
                        }
                        if (this._loadNodeCallback) {
                            this._loadNodeCallback(nodeId);
                        }
                    }
                    // switch classes
                    clickedItem.classList.remove(NODE_CLOSED_ITEM_CLASS);
                    clickedItem.classList.add(NODE_OPENED_ITEM_CLASS);
                    icon.classList.remove(...this._nodeIconClosed);
                    icon.classList.add(...this._nodeIconOpened);
                    // open children
                    this._core.Functions.showElement(childList);
                };
                this._nodeSearchKeyUp = (event) => {
                    this._log.info("DataTreeComponent._nodeSearchKeyUp()");
                    if (event.key === "Enter") {
                        let target = event.currentTarget;
                        let nodeId = target.parentElement.getAttribute(SEARCH_PARENT_ID_ATTRIBUTE);
                        let searchValue = target.value;
                        if (this._searchNodeCallback) {
                            this._searchNodeCallback(nodeId, searchValue);
                        }
                    }
                };
                this._nodeSearchClicked = (event) => {
                    this._log.info("DataTreeComponent._nodeSearchClicked()");
                    let clickedItem = event.currentTarget;
                    let parent = clickedItem.parentElement.parentElement;
                    let nodeId = parent.getAttribute(SEARCH_PARENT_ID_ATTRIBUTE);
                    let searchValue = parent.querySelector('input').value;
                    if (this._searchNodeCallback) {
                        this._searchNodeCallback(nodeId, searchValue);
                    }
                };
                this._addLeaves = (parentNode, parentId, leaves, moreLeaves = false) => {
                    this._log.info("DataTreeComponent._addLeaves()");
                    let length = leaves.length;
                    if (this._maxLeaves >= 0 && length > this._maxLeaves) {
                        let searchItem = this._createLeafSearch(parentId);
                        parentNode.appendChild(searchItem);
                    }
                    else {
                        if (length <= 0 && this._noLeavesText && parentId != Widgets.TREE_ROOT) {
                            if (this._log.isTraceEnabled()) {
                                this._log.trace("adding no leaves text for parent: " + parentId);
                            }
                            let txtItem = this._createTextItem(this._noLeavesText);
                            parentNode.appendChild(txtItem);
                        }
                        else {
                            for (let i = 0; i < length; i++) {
                                let leafData = leaves[i];
                                let leafItem = this._createLeafItem(leafData);
                                parentNode.appendChild(leafItem);
                            }
                            if (moreLeaves) {
                                if (this._moreLeavesText) {
                                    let txtItem = this._createTextItem(this._moreLeavesText);
                                    parentNode.appendChild(txtItem);
                                }
                                else {
                                    let searchItem = this._createLeafSearch(parentId);
                                    parentNode.appendChild(searchItem);
                                }
                            }
                        }
                    }
                };
                this._createLeafItem = (data) => {
                    this._log.info("DataTreeComponent._createLeafItem()");
                    let leafItem = document.createElement('li');
                    leafItem.id = LEAF_ID_PREFIX + data.Id;
                    let leafDiv = document.createElement('div');
                    leafItem.appendChild(leafDiv);
                    leafDiv.addEventListener('click', this._leafItemClicked);
                    leafDiv.classList.add(ITEM_CLASS, LEAF_ITEM_CLASS);
                    leafDiv.setAttribute(LEAF_ID_ATTRIBUTE, data.Id);
                    let iconSpan = document.createElement('span');
                    leafDiv.appendChild(iconSpan);
                    iconSpan.classList.add(ITEM_ICON_CLASS, ...this._leafIcon);
                    let nameSpan = document.createElement('span');
                    leafDiv.appendChild(nameSpan);
                    nameSpan.classList.add(ITEM_TEXT_CLASS);
                    nameSpan.textContent = data.DisplayName;
                    return leafItem;
                };
                this._createLeafSearch = (parentId) => {
                    this._log.info("DataTreeComponent._createLeafSearch()");
                    let searchItem = document.createElement('li');
                    searchItem.id = SEARCH_LEAF_ID_PREFIX + parentId;
                    let leafDiv = document.createElement('div');
                    searchItem.appendChild(leafDiv);
                    leafDiv.classList.add(ITEM_CLASS, LEAF_ITEM_CLASS, SEARCH_ITEM_CLASS);
                    let iconSpan = document.createElement('span');
                    leafDiv.appendChild(iconSpan);
                    iconSpan.classList.add(ITEM_ICON_CLASS, ...this._leafIcon);
                    let searchDiv = document.createElement('div');
                    leafDiv.appendChild(searchDiv);
                    searchDiv.classList.add(ITEM_SEARCH_CLASS);
                    let searchInputDiv = document.createElement('div');
                    searchDiv.appendChild(searchInputDiv);
                    searchInputDiv.classList.add(...SEARCH_INPUT_DIV_CLASSES);
                    searchInputDiv.setAttribute(SEARCH_PARENT_ID_ATTRIBUTE, parentId);
                    let searchInput = document.createElement('input');
                    searchInputDiv.appendChild(searchInput);
                    searchInput.type = 'search';
                    searchInput.classList.add(...SEARCH_INPUT_INPUT_CLASSES);
                    if (this._leafSearchText) {
                        searchInput.placeholder = this._leafSearchText;
                        searchInput.setAttribute('aria-label', this._leafSearchText);
                    }
                    searchInput.addEventListener('keyup', this._leafSearchKeyUp);
                    let searchIconDiv = document.createElement('div');
                    searchInputDiv.appendChild(searchIconDiv);
                    searchIconDiv.classList.add(...SEARCH_INPUT_ICON_CLASSES);
                    let searchIconSpan = document.createElement('span');
                    searchIconDiv.appendChild(searchIconSpan);
                    searchIconSpan.addEventListener('click', this._leafSearchClicked);
                    searchIconSpan.classList.add(...SEARCH_INPUT_ICON_ITEM_CLASSES, ...this._searchIcon);
                    return searchItem;
                };
                this._leafItemClicked = (event) => {
                    this._log.info("DataTreeComponent._leafItemClicked()");
                    let clickedItem = event.currentTarget;
                    let leafId = clickedItem.getAttribute(LEAF_ID_ATTRIBUTE);
                    if (this._selectLeafCallback) {
                        this._selectLeafCallback(leafId);
                    }
                };
                this._leafSearchKeyUp = (event) => {
                    this._log.info("DataTreeComponent._leafSearchKeyUp()");
                    if (event.key === "Enter") {
                        let target = event.currentTarget;
                        let leafId = target.parentElement.getAttribute(SEARCH_PARENT_ID_ATTRIBUTE);
                        let searchValue = target.value;
                        if (this._searchLeafCallback) {
                            this._searchLeafCallback(leafId, searchValue);
                        }
                    }
                };
                this._leafSearchClicked = (event) => {
                    this._log.info("DataTreeComponent._leafSearchClicked()");
                    let clickedItem = event.currentTarget;
                    let parent = clickedItem.parentElement.parentElement;
                    let leafId = parent.getAttribute(SEARCH_PARENT_ID_ATTRIBUTE);
                    let searchValue = parent.querySelector('input').value;
                    if (this._searchLeafCallback) {
                        this._searchLeafCallback(leafId, searchValue);
                    }
                };
                this._log = this._core.Logging.getLogger(LOG_CATEGORY);
                this._log.info("DataTreeComponent::constructor");
                if (config) {
                    this._config = config;
                }
                else {
                    this._config = {};
                }
                this._isReady = false;
                this._isWaitingDisplayData = false;
                if (this._config.hasOwnProperty('DisplayLeavesBeforeNodes') && this._config.DisplayLeavesBeforeNodes) {
                    this._displayLeavesBeforeNodes = this._config.DisplayLeavesBeforeNodes;
                }
                else {
                    this._displayLeavesBeforeNodes = false;
                }
                if (this._config.hasOwnProperty('LoadNodeCallback') && this._config.LoadNodeCallback) {
                    this._loadNodeCallback = this._config.LoadNodeCallback;
                }
                if (this._config.hasOwnProperty('SelectNodeCallback') && this._config.SelectNodeCallback) {
                    this._selectNodeCallback = this._config.SelectNodeCallback;
                }
                if (this._config.hasOwnProperty('SelectLeafCallback') && this._config.SelectLeafCallback) {
                    this._selectLeafCallback = this._config.SelectLeafCallback;
                }
                if (this._config.hasOwnProperty('SearchNodeCallback') && this._config.SearchNodeCallback) {
                    this._searchNodeCallback = this._config.SearchNodeCallback;
                }
                if (this._config.hasOwnProperty('SearchLeafCallback') && this._config.SearchLeafCallback) {
                    this._searchLeafCallback = this._config.SearchLeafCallback;
                }
                if (this._config.hasOwnProperty('NodeIconOpened') && this._config.NodeIconOpened.length > 0) {
                    this._nodeIconOpened = this._config.NodeIconOpened.split(" ");
                }
                else {
                    this._nodeIconOpened = NODE_ICON_OPENED.split(" ");
                }
                if (this._config.hasOwnProperty('NodeIconClosed') && this._config.NodeIconClosed.length > 0) {
                    this._nodeIconClosed = this._config.NodeIconClosed.split(" ");
                }
                else {
                    this._nodeIconClosed = NODE_ICON_CLOSED.split(" ");
                }
                if (this._config.hasOwnProperty('LeafIcon') && this._config.LeafIcon.length > 0) {
                    this._leafIcon = this._config.LeafIcon.split(" ");
                }
                else {
                    this._leafIcon = LEAF_ICON.split(" ");
                }
                if (this._config.hasOwnProperty('SearchIcon') && this._config.SearchIcon.length > 0) {
                    this._searchIcon = this._config.SearchIcon.split(" ");
                }
                else {
                    this._searchIcon = SEARCH_ICON.split(" ");
                }
                if (this._config.hasOwnProperty('MaxNodes') && this._config.MaxNodes) {
                    this._maxNodes = this._config.MaxNodes;
                }
                else {
                    this._maxNodes = -1;
                }
                if (this._config.hasOwnProperty('MaxLeaves') && this._config.MaxLeaves) {
                    this._maxLeaves = this._config.MaxLeaves;
                }
                else {
                    this._maxLeaves = -1;
                }
                if (this._config.hasOwnProperty('NodeSearchText') && this._config.NodeSearchText) {
                    this._nodeSearchText = this._config.NodeSearchText;
                }
                if (this._config.hasOwnProperty('LeafSearchText') && this._config.LeafSearchText) {
                    this._leafSearchText = this._config.LeafSearchText;
                }
                if (this._config.hasOwnProperty('MoreNodesText') && this._config.MoreNodesText) {
                    this._moreNodesText = this._config.MoreNodesText;
                }
                if (this._config.hasOwnProperty('NoNodesText') && this._config.NoNodesText) {
                    this._noNodesText = this._config.NoNodesText;
                }
                if (this._config.hasOwnProperty('MoreLeavesText') && this._config.MoreLeavesText) {
                    this._moreLeavesText = this._config.MoreLeavesText;
                }
                if (this._config.hasOwnProperty('NoLeavesText') && this._config.NoLeavesText) {
                    this._noLeavesText = this._config.NoLeavesText;
                }
                if (!ComponentDataTree.Html) {
                    core.Loader.getVersionedHTML('widgets/components/dataTree.html', this._storeHtml, core.Helper.missingHtmlErrorCallback);
                }
                else {
                    this._readyToPresent = true;
                    if (this._waitingToPresent)
                        this._present();
                }
            }
        }
        ComponentDataTree.Html = null;
        Widgets.ComponentDataTree = ComponentDataTree;
    })(Widgets = WPTNamespace.Widgets || (WPTNamespace.Widgets = {}));
})(WPTNamespace || (WPTNamespace = {}));
